module.exports = __webpack_public_path__ + "static/media/icon-check.ba447259.svg";